import React, { useContext, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import TokenService from "../services/auth/TokenService";
import { Context } from "./auth_components/state/Store";

const Navbar = (props) => {
  const history = useHistory();
  const [, dispatch] = useContext(Context);
  const location = useLocation();
  const [bookInput, setBookInput] = useState("");

  // Extract the bookId from the pathname
  const getBookIdFromPathname = () => {
    console.log(location);
    const pathParts = location.pathname.split("/");
    const bookId = pathParts[2]; // Assuming the path is always /books/{bookId}
    console.log("Extracted bookId:", bookId);
    return bookId;
  };

  const bookId = getBookIdFromPathname(); // Corrected to extract from pathname
  const onSubmitBookId = (e) => {
    e.preventDefault();
    const value = bookInput.trim();
    if (!value) return;
    history.push(`/authoring-tool-2.0?book=${encodeURIComponent(value)}`);
  };

  return (
    <nav className="top-navigation">
      <li className="top-navigation__item">
        <Link to={"/books"} className="top-navigation__link spaced">
          <img src="/dpi-white-logo.svg" alt="" style={{ height: 32, width: 32 }} />
        </Link>
      </li>
      <li className="top-navigation__item">
        {/* Only include the book parameter if bookId is defined */}
        <Link
          to={`/authoring-tool-2.0${bookId ? `?book=${bookId}` : ""}`}
          className="top-navigation__link"
          style={{ fontVariation: "bold" }}
        >
          Authoring Tool 2.0
        </Link>
      </li>
      <li className="top-navigation__item" style={{ display: "flex", alignItems: "center" }}>
        <form onSubmit={onSubmitBookId} style={{ display: "flex", gap: 8 }}>
          <input
            type="text"
            placeholder="Enter book id…"
            value={bookInput}
            onChange={(e) => setBookInput(e.target.value)}
            style={{
              height: 28,
              padding: "0 8px",
              borderRadius: 4,
              border: "1px solid #ccc",
              maxWidth: 125,
            }}
          />
          <button
            type="submit"
            className="top-navigation__link"
            style={{
              height: 28,
              lineHeight: "28px",
              padding: "0 10px",
              borderRadius: 4,
              border: "none",
              background: "#2563eb",
              color: "white",
              cursor: "pointer",
            }}
          >
            Open
          </button>
        </form>
      </li>
      <li className="top-navigation__item">
        <Link to={"/books"} className="top-navigation__link">
          Search
        </Link>
      </li>
      <li className="top-navigation__item">
        <Link to={"/add"} className="top-navigation__link">
          Add
        </Link>
      </li>
      <li className="top-navigation__item">
        <Link to={"/categories"} className="top-navigation__link">
          Categories
        </Link>
      </li>
      <li className="top-navigation__item">
        <Link to={"/domains"} className="top-navigation__link">
          Domains
        </Link>
      </li>
      <li className="top-navigation__item">
        <Link to={"/creators"} className="top-navigation__link">
          Creators
        </Link>
      </li>
      <li className="top-navigation__item">
        <Link to={"/showcases"} className="top-navigation__link">
          Showcases
        </Link>
      </li>
      <li className="top-navigation__item">
        <Link to={"/heres-america-manager"} className="top-navigation__link">
          Dreamers' Land
        </Link>
      </li>{" "}
      {/* <li className="top-navigation__item">
        <Link to={"/smart-reach"} className="top-navigation__link">
          Smart Reach
        </Link>
      </li> */}
      {TokenService.getUser() && (
        <li className="top-navigation__item logout-button">
          <Link
            to="/login"
            className="top-navigation__link"
            onClick={() => {
              TokenService.removeUser();
              history.push("/login");
              dispatch({ type: "LOG_OUT" });
            }}
          >
            Logout
          </Link>
        </li>
      )}
    </nav>
  );
};

export default Navbar;
